import type { ReactionsResults } from '@mentimeter/http-clients';
import * as React from 'react';

const reactionsResults = React.createContext<ReactionsResults | undefined>(
  undefined,
);
reactionsResults.displayName = 'ReactionsResultsContext';
export const ReactionsResultsProvider = reactionsResults.Provider;
export const useReactionsResults = () => React.useContext(reactionsResults);
